export default __webpack_public_path__ + "static/media/s4.cd644fc1.jpg";